import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ActivitySpinner from 'components/shared/ActivitySpinner';
import CrossIcon from 'components/shared/icons/CrossIcon';
import TriangleIcon from 'components/shared/icons/TriangleIcon';
import TickIcon from 'components/shared/icons/TickIcon';
import InfoIcon from 'components/shared/icons/InfoIcon';

import './NotificationBanner.scss';

class NotificationBanner extends React.Component {
  static propTypes = {
    dangerouslySetTextString: PropTypes.string.isRequired,
    iconType: PropTypes.string.isRequired,
    isFixed: PropTypes.bool,
    onClick: PropTypes.func,
    onClickBanner: PropTypes.func,
    onDismiss: PropTypes.func,
    titleString: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    onDismiss: undefined,
  };

  static IconTypes = {
    spinner: 'SPINNER',
    pending: 'PENDING',
    success: 'SUCCESS',
    failure: 'FAILURE',
    info: 'INFO',
  }

  renderIcon() {
    switch (this.props.iconType) {
      case NotificationBanner.IconTypes.spinner: return <ActivitySpinner isActive size={3} />;
      case NotificationBanner.IconTypes.pending: return <TriangleIcon />;
      case NotificationBanner.IconTypes.success: return <TickIcon size={24} />;
      case NotificationBanner.IconTypes.info: return <InfoIcon />;
      // TODO: Use an error icon svg instead of a gylphicon
      case NotificationBanner.IconTypes.failure: return <span className="glyphicon glyphicon-ban-circle" />;
      default: return null;
    }
  }

  renderNotificationText() {
    const { titleString, dangerouslySetTextString } = this.props;

    // Do not pass in user input because of XSS risks with dangerouslySetInnerHTML
    const statusText = <div dangerouslySetInnerHTML={{ __html: dangerouslySetTextString }} />;

    if (!titleString) {
      return statusText;
    }

    return (
      <div>
        <div className="aa-notification-banner-title">
          {titleString}
        </div>
        {statusText}
      </div>
    );
  }

  renderDismissButton() {
    return (
      <div className="aa-notification-banner-icon col-xs-2 col-md-1">
        <a href="#" onClick={this.props.onDismiss}>
          <CrossIcon color="#9A9A9A" />
        </a>
      </div>
    );
  }

  render() {
    const {
      onClick, onClickBanner, onDismiss, className, isFixed,
    } = this.props;
    const wrapperClassName = classNames(
      'aa-notification-banner-wrapper',
      className,
      { fixed: isFixed },
      { touchable: onClick },
    );

    return (
      <div className={wrapperClassName} onClick={onClick}>
        <div className="container-fluid">
          <div className="row aa-notification-banner">
            <div className="aa-notification-banner-icon" onClick={onClickBanner}>
              <div className="aa-notification-banner-icon-wrapper">
                {this.renderIcon()}
              </div>
            </div>
            <div className="aa-notification-banner-text" onClick={onClickBanner}>
              {this.renderNotificationText()}
            </div>
            {onDismiss ? this.renderDismissButton() : null}
          </div>
        </div>
      </div>
    );
  }
}

export default NotificationBanner;
